import { Component } from '@angular/core';
import { LanguageService } from '../../services/language'; 
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe],
  selector: 'app-contact',
  styleUrl: './contact.component.css',
  templateUrl: './contact.component.html',
})
export class ContactComponent {
constructor(public languageService: LanguageService){}

  toggleLanguage(): void {
    const current = this.languageService.getLanguage();

    this.languageService.changeLanguage(
      current === 'ar' ? 'en' : 'ar'
    );
  }
}
